import { createStore, applyMiddleware } from "redux"; 
import thunk from "redux-thunk"; 
// import config from "config"; 
// logger used to log reduc actions and state in the browser 
// see: https://github.com/evgenyrodionov/redux-logger 
import { createLogger } from "redux-logger"; 
import rootReducer from "../reducers"; 
 
const nextRootReducer = require("../reducers").default; 
 
const configureStore = preloadedState => { 
  // console.log('Configuring the store:', JSON.stringify(config)); 
  let middleware = [thunk]; 
  // In production and in test environment delete the redux-logger 
  // if (config.isConsoleLogEnabled) { 
  //   // console log is enabled 
  //   // console.log('Creating the redux logger.'); 
  //   const logger = createLogger(); 
  //   middleware = [...middleware, logger]; 
  // } 
  const logger = createLogger(); 
  middleware = [...middleware, logger]; 
 
  const store = createStore( 
    rootReducer, 
    preloadedState, 
    applyMiddleware(...middleware) 
  ); 
 
  if (module.hot) { 
    // Enable Webpack hot module replacement for reducers 
    module.hot.accept("../reducers", () => { 
      store.replaceReducer(nextRootReducer); 
    }); 
  } 
 
  return store; 
}; 
 
export default configureStore; 



// WEBPACK FOOTER //
// ./src/Language/configureStore.js